import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class VendorNameApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.VENDOR_NAME);
  }
}

export default new VendorNameApi();
